import defs from '../_core/defs.js';
// returns an array which contains all data keys
export default function keys() {
  var def = defs.get(this);
  /* istanbul ignore if */
  if (!def) {
    return [];
  }
  return Object.keys(def.keys);
}